import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { GetAllAttorneysTransactionsResponseTransactionDto } from 'app/API';

export const ATTORNEYS_REPORT_CSV_HEADERS = [
  'ID',
  'Date',
  'Email',
  'Job',
  'Inviter',
  'Status',
  'Stripe Invoice',
  'Price',
];

export const buildAttorneysReportCsvRows = (transactions: GetAllAttorneysTransactionsResponseTransactionDto[]) =>
  transactions.map((transaction) => ({
    id: transaction.id,
    date: getAmericanTime(transaction.createdAt),
    email: transaction.attorneyEmail ?? '-',
    job: `${transaction.RecordingSession?.job?.name ?? ''} (${transaction.RecordingSession?.jobId ?? ''})`,
    inviter: transaction.Inviter
      ? `${transaction.Inviter.name} ${transaction.Inviter.lastname} (${transaction.Inviter.email})`
      : '-',
    status: transaction.type === 'attorney_invitation' ? 'Invitation' : 'Connection',
    invoice: transaction.stripeChargeId || '-',
    price: `$${transaction.priceAmount / 100}`,
  }));
